module.exports = __webpack_public_path__ + "static/media/cask-bottles.8695ea37.png";